import { FC } from 'react';
import styled from 'styled-components';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';
import { IconChevronRight } from '@tabler/icons-react';
import { Restaurant } from '../../../API';
import { TypographyStyled } from '../../Styled/Typography';
import { Link } from '@cfa/react-core';

interface Props {
  location: Restaurant;
  ticketPath: string;
}

const LocationWithUpdate = styled.div`
  margin-bottom: ${themeSizes.lg};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

   a {
    margin-right: ${themeSizes.md}
    display: flex;
    align-self: center;

    svg {
      margin-left: ${themeSizes.sm};
    }
  }
`;

const SeeTicketLink = styled(Link)`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
`;

export const ChildCaseTicketLink: FC<Props> = ({ location, ticketPath }) => (
  <LocationWithUpdate key={location.id}>
    <div>
      <TypographyStyled
        text={location.name ?? ''}
        fontWeight='medium'
        style={{ marginBottom: themeSizes.xs }}
        color={themeColors.colorGray_7}
      />
      <TypographyStyled text={location.number} variant='body2' />
    </div>
    <SeeTicketLink href={ticketPath}>
      See ticket
      <IconChevronRight size={themeSizes.md} />
    </SeeTicketLink>
  </LocationWithUpdate>
);
